import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";

export default function Frameworks() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/frameworks").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-10">
      <header className="fade-up">
        <div className="overline mb-3">Framework Explorer</div>
        <h1 className="font-display text-5xl lg:text-6xl tracking-tighter leading-[0.95]">Three frameworks.<br/>One map.</h1>
        <p className="text-muted-foreground mt-4 max-w-2xl">
          Voluntary · Certifiable · Binding. Study each on its own and cross-walk between them.
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-l border-border fade-up delay-1">
        {items.map((f) => (
          <Link key={f.id} to={`/app/frameworks/${f.id}`}
            data-testid={`framework-card-${f.id}`}
            className="p-8 bg-white border-r border-b border-border hover:bg-secondary transition-colors group flex flex-col">
            <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground">{f.issuer}</div>
            <div className="font-display text-3xl mt-3 leading-tight">{f.short}</div>
            <div className="text-sm text-foreground mt-1">{f.name}</div>
            <p className="text-sm text-muted-foreground mt-4 flex-1">{f.summary}</p>
            <div className="mt-6 flex items-center gap-2 text-sm font-medium text-primary">
              Explore <ArrowRight size={14} weight="bold" className="group-hover:translate-x-1 transition-transform" />
            </div>
            <div className="mt-4 text-xs font-mono uppercase tracking-widest text-muted-foreground">
              Released · {f.released}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
